var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"position--relative"},[_c('strong',{staticClass:"font--18px font--800",class:_vm.required ? 'is-essential' : ''},[_vm._v(_vm._s(_vm.label))])])}
var staticRenderFns = []

export { render, staticRenderFns }